<template>
  <img src="/vue/images/vk.png" id="login_button" @click="login()">
</template>

<script>
import functions from "./functions.js";

export default {
  mixins: [functions],
  mounted() {
    VK.init({ apiId: 7026259 });
  },
  methods: {
    login() {
      VK.Auth.login(this.authorize);
    },
    authorize(data) {
      if (data.status != "unknown") {
        VK.Api.call(
          "users.get",
          {
            user_ids: data.session.user.id,
            fields: "id,first_name,last_name,photo_max_orig,email",
            v: 5.92,
            scope: "email"
          },
          r => {
            if (r.response[0].id != undefined) {
              let profile = r.response[0];
              this.socLogin(
                profile.first_name,
                profile.last_name,
                profile.id,
                profile.photo_max_orig,
                profile.email,
                "vk"
              );
            }
          }
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/social/vk.vue